<template>
  <div style="margin-top: 113px">
      <v-card>
        <v-card-title>Campaigns of PDR</v-card-title>
        <v-snackbar v-model="isMsg" :color="getColor()">
          <b> {{ message }} </b>
        </v-snackbar>
        <v-card-text>
          <v-row cols="6">
            <v-col cols="3">
              <v-select
                v-model="country"
                :items="refCountries"
                label="perimeter"
                item-text="label"
                item-value="code"
                v-on:change="filter"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="selectedYear"
                :items="yearList"
                label="year"
                v-on:change="filter"
              ></v-select>
            </v-col>
            <v-col
              cols="3"
              v-if="
                selectedYear != null &&
                  selectedYear != '' &&
                  (perimeterAdmin == null || perimeterAdmin == 'all')
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text @click="csv(selectedYear, null, false)">
                    <v-icon>mdi-file-delimited-outline</v-icon>
                  </v-btn>
                </template>
                <span>Export {{ selectedYear }} reviews as CSV</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text @click="csv(selectedYear, null, true)">
                    <v-icon>mdi-database-export</v-icon>
                  </v-btn>
                </template>
                <span
                  >Export {{ selectedYear }} reviews with all data as CSV</span
                >
              </v-tooltip>
            </v-col>
          </v-row>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="general-background">
                  <th class="text-left col-elem border-elem" rowspan="2">
                    <b>Year</b>
                  </th>
                  <th class="text-left col-elem border-elem" rowspan="2">
                    <b>Perimeter</b>
                  </th>
                  <th class="text-left col-elem border-elem" rowspan="2">
                    <b>Status</b>
                  </th>
                  <th class="text-left col-elem border-elem" rowspan="2">
                    <b>Starting date</b>
                  </th>
                  <th class="text-left col-elem border-elem" rowspan="2">
                    <b>Total reviews</b>
                  </th>
                  <th class="text-left col-elem border-elem" colspan="4">
                    <b class="align-center">Status reviews first part</b>
                  </th>
                  <th class="text-left col-elem border-elem" colspan="4">
                   <b class="align-center">Status reviews second part</b>
                  </th>
                  <th class="text-left col-elem border-elem" rowspan="2">
                    <b>Action</b>
                  </th>
                </tr>
                <tr class="general-background">
                  <th class="text-left col-elem border-elem" scope="col">
                    <b>Employee</b>
                  </th>
                  <th class="text-left col-elem border-elem" scope="col">
                    <b>Manager</b>
                  </th>
                  <th class="text-left col-elem border-elem" scope="col">
                    <b>Closed</b>
                  </th>
                  <th class="text-left col-elem border-elem" scope="col">
                    <b>finalise by date</b>
                  </th>
                  <th class="text-left col-elem border-elem" scope="col">
                    <b>Employee</b>
                  </th>
                  <th class="text-left col-elem border-elem" scope="col">
                    <b>Manager</b>
                  </th>
                  <th class="text-left col-elem border-elem" scope="col">
                    <b>Closed</b>
                  </th>
                  <th class="text-left col-elem border-elem" scope="col">
                    <b>finalise by date</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="campaign in filteredCampaigns" v-bind:key="campaign.id">
                  <th class="text-left border-elem">{{ campaign.year }}</th>
                  <th class="text-left border-elem">
                    {{ campaign.country.code }}
                  </th>
                  <th class="text-left border-elem">{{ campaign.status }}</th>
                  <th class="text-left border-elem">
                    {{ campaign.startingDate }}
                  </th>
                  <th class="text-left border-elem">
                    {{ campaign.nbReviews }}
                  </th>
                  <th class="text-left border-elem">
                    {{
                      campaign.nbReviewsFirstPartEmpProp +
                        campaign.nbReviewsFirstPartEmpNotif
                    }}
                  </th>
                  <th class="text-left border-elem">
                    {{
                      campaign.nbReviewsFirstPartSlmProp +
                        campaign.nbReviewsFirstPartDlmProp +
                        campaign.nbReviewsFirstPartSlmBack
                    }}
                  </th>
                  <th class="text-left border-elem">
                    {{
                      campaign.nbReviewsFirstPartClosed +
                        campaign.nbReviewsFirstPartClosedRh
                    }}
                  </th>
                  <th class="text-left border-elem">
                    {{ campaign.finaliseByDateFP }}
                  </th>
                  <th class="text-left border-elem">
                    {{
                      campaign.nbReviewsSecondPartEmpProp +
                        campaign.nbReviewsSecondPartEmpNotif
                    }}
                  </th>
                  <th class="text-left border-elem">
                    {{
                      campaign.nbReviewsSecondPartSlmProp +
                        campaign.nbReviewsSecondPartDlmProp +
                        campaign.nbReviewsSecondPartSlmBack
                    }}
                  </th>
                  <th class="text-left border-elem">
                    {{
                      campaign.nbReviewsSecondPartClosed +
                        campaign.nbReviewsSecondPartClosedRh
                    }}
                  </th>
                  <th class="text-left border-elem">
                    {{ campaign.finaliseByDateSP }}
                  </th>
                  <th class="text-left border-elem">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          text
                          @click="
                            closeCampaign(campaign.year, campaign.country.code)
                          "
                          v-if="campaign.status != 'CLOSED'"
                        >
                          <v-icon color="red">mdi-stop-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>WARNING ! Close campaign</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          text
                          @click="
                            csv(campaign.year, campaign.country.code, false)
                          "
                        >
                          <v-icon>mdi-file-delimited-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Export reviews as CSV</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          text
                          @click="
                            csv(campaign.year, campaign.country.code, true)
                          "
                        >
                          <v-icon>mdi-database-export</v-icon>
                        </v-btn>
                      </template>
                      <span>Export reviews with all data as CSV</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text @click="openUdapteDateDialog(campaign)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Update finalization date</span>
                    </v-tooltip>
                  </th>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="1" style="margin-top: 22px">
                <H6>Next : </H6>
              </v-col>
              <v-col cols="2">
                <v-radio-group v-model="nextCampaignYear">
                  <v-radio
                    :label="'year :' + previousYear"
                    :value="previousYear"
                  ></v-radio>
                  <v-radio
                    :label="'year :' + currentYear"
                    :value="currentYear"
                  ></v-radio>
                  <v-radio
                    :label="'year :' + nextYear"
                    :value="nextYear"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="4">
                <v-btn
                    style="margin-top: 17px"
                  @click="startCampaign"
                  :disabled="country == null || country == ''"
                  class=" ml-2 mb-3"
                  color="success"
                  >Start campaign {{ nextCampaignYear }} {{ country }}</v-btn
                >
                <v-progress-circular
                  v-if="wait"
                  indeterminate
                  color="green"
                ></v-progress-circular>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline"
            ><span>Close campaign {{ campaignToClose }} </span></v-card-title
          >
          <v-card-text>
            <v-container>
              <span
                >Are you sure you want to close campaign
                {{ campaignToClose }} ?</span
              >
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    type="password"
                    label="Confirme your password"
                    required
                    v-model="confirmPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false"
              >No</v-btn
            >
            <v-btn color="orange darken-1" text @click="close(false)"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogConfirmed" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">
            <v-icon>mdi-alert-outline</v-icon> Warning
            <v-icon>mdi-alert-outline</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <span
                >There's still reviews opened for campaign
                {{ campaignToClose }} do you want to force to close all of them
                ?</span
              >
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    type="password"
                    label="Confirme your password"
                    required
                    v-model="confirmPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogConfirmed = false"
              >No</v-btn
            >
            <v-btn color="orange darken-1" text @click="close(true)">Yes</v-btn>
            <v-progress-circular
              v-if="wait"
              indeterminate
              color="green"
            ></v-progress-circular>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdateCampaign" persistent max-width="800">
        <v-card>
          <v-card-title>Update finalization date</v-card-title>
          <v-card-text>
            <h6>Review first part</h6>
            <v-row>
              <v-col cols="12" lg="6">
                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="campaignToUpdate.finaliseByDateFP" label="Date" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="campaignToUpdate.finaliseByDateFP" no-title @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <h6>Review second part</h6>
            <v-row>
              <v-col cols="12" lg="6">
                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="campaignToUpdate.finaliseByDateSP" label="Date" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="campaignToUpdate.finaliseByDateSP" no-title @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="button" class="v-btn v-btn--contained theme--light v-size--default success" @click="updateFinalizationDate()">Validate</v-btn>
            <v-btn type="button" class="v-btn v-btn--contained theme--light v-size--default warning" text @click="dialogUpdateCampaign = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<style>
.align-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "Campaign",
  data() {
    return {
      startPeriod: null,
      endPeriod: null,
      country: null,
      isMsg: false,
      openDialog: false,
      message: "",
      error: false,
      wait: false,
      forceClose: false,
      currentYear: new Date().getFullYear(),
      previousYear: new Date().getFullYear() - 1,
      nextYear: new Date().getFullYear() + 1,
      nextCampaignYear: new Date().getFullYear() + 1,
      campaigns: [],
      filteredCampaigns: [],
      yearList: [],
      dialog: false,
      dialogConfirmed: false,
      campaignToClose: "",
      confirmPassword: "",
      refCountries: [],
      campaignCountryToClose: "",
      selectedYear: new Date().getFullYear(),
      dialogUpdateCampaign: false,
      campaignToUpdate: {},
      menu1: false,
      menu2: false,
    };
  },
  created() {
    this.loadRefCountry();
  },
  mounted: function() {
    this.loadCampaigns();
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      perimeterAdmin: "auth/perimeterAdmin",
    }),
  },
  methods: {
    updateFinalizationDate(){
      console.log(this.campaignToUpdate);

      const apiUrl = process.env.VUE_APP_ROOT_API_PATH + 'api/campaings/update/finalization-date';
      const config = {
        headers: {'Content-Type': 'application/json'},
        withCredentials: true
      };

      axios.put(apiUrl, this.campaignToUpdate, config)
      .then((response) => {
        if (response.status == "200" || response.status == "201") {
          this.message = "Campain updated successfully";
          this.error = false;
          this.isMsg = true;
          this.dialogUpdateCampaign = false;
        } else {
          this.message = "An error happened, please try again later";
          this.error = true;
          this.isMsg = true;
        }
      }).catch(() => {
        this.message = "An error happened, please try again later";
        this.error = true;
        this.isMsg = true;
      });
    },

    openUdapteDateDialog(campaign){
      this.campaignToUpdate = campaign;
      this.dialogUpdateCampaign = true;
    },

    clearFilter() {
      this.filteredCampaigns = this.campaigns;
      this.yearList = this.filteredCampaigns
        .map((campaign) => campaign.year)
        .sort();
    },
    filter() {
      this.clearFilter();
      this.filterCountry();
      this.filterYear();
    },
    filterCountry() {
      if (this.country) {
        this.filteredCampaigns = this.filteredCampaigns.filter((campaign) => {
          if (campaign.country && campaign.country.code == this.country) {
            return true;
          }
        });
      } else if (this.country == "") {
        this.filteredCampaigns = this.filteredCampaigns.filter((campaign) => {
          if (
            campaign.country == null ||
            campaign.country == "" ||
            campaign.country.code == "" ||
            campaign.country.code == null
          ) {
            return true;
          }
        });
      }
    },
    filterYear() {
      if (this.selectedYear && this.selectedYear != "") {
        this.filteredCampaigns = this.filteredCampaigns.filter((campaign) => {
          return campaign.year === this.selectedYear;
        });
      }
    },
    loadRefCountry: function() {
      this.getCountries();
    },
    getCountries: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/countries", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          if (this.perimeterAdmin == null || this.perimeterAdmin == "all") {
            this.refCountries = json.data;
            //Add empty
            this.refCountries.push({
              code: "",
              label: "",
            });
          } else {
            let valueToCompare = this.perimeterAdmin.split(",");
            if (valueToCompare.length > 1) {
              this.country = "";
            } else {
              this.country = valueToCompare[0];
            }
            this.refCountries = valueToCompare;
          }
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    loadCampaigns() {
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/campaings?stats=true", {
        method: "get",
        credentials: "include",
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          console.log(response);
          this.campaigns = response.data;
          this.wait = false;
          for (let i = 0; i <= response.data; i++) {
            if (response.data[i].year == this.currentYear)
              this.startPeriod = response.data[i].startPeriod;
            this.endPeriod = response.data[i].endPeriod;
          }
          this.filteredCampaigns = this.campaigns;
          this.yearList = this.filteredCampaigns
            .map((campaign) => campaign.year)
            .sort();
          this.filterYear();
        });
    },
    getColor: function() {
      if (this.error) {
        return "red darken-2";
      } else {
        return "green darken-2";
      }
    },
    close: function(force) {
      this.forceClose = force;
      this.dialog = false;
      this.dialogConfirmed = false;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      this.wait = true;
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/campaings?year=" +
          this.campaignToClose +
          "&country=" +
          this.campaignCountryToClose +
          "&force=" +
          this.forceClose +
          "&password=" +
          this.confirmPassword,
        {
          method: "PUT",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          this.confirmPassword = "";
          return response.json();
        })
        .then((json) => {
          if (json.status == "200") {
            if (json.data == false) {
              this.dialogConfirmed = true;
              this.wait = false;
            } else {
              this.loadCampaigns();
            }
          } else {
            this.wait = false;
            this.error = true;
            this.isMsg = true;
            this.message = json.message;
          }
        })
        .catch((err) => {
          this.error = true;
          this.isMsg = true;
          this.message = err;
        });
    },
    closeCampaign: function(yearToClose, countryToClose) {
      this.campaignToClose = yearToClose;
      this.campaignCountryToClose = countryToClose;
      this.dialog = true;
    },
    startCampaign: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      this.wait = true;
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/campaings?year=" +
          this.nextCampaignYear +
          "&country=" +
          this.country,
        {
          method: "POST",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (json.status == "200") {
            this.error = false;
            this.isMsg = true;
            this.message = json.data;
          } else {
            this.error = true;
            this.isMsg = true;
            this.message = json.message;
          }
          this.loadCampaigns();
        })
        .catch((err) => {
          this.error = true;
          this.isMsg = true;
          this.message = err;
          this.wait = false;
        });
    },
    csv(year, country, all) {
      var apiPath = "api/reviews/export/";
      if (all) {
        apiPath = "api/reviews/exportAll/";
      }
      if (country == "") {
        country = "null";
      }
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + apiPath + year + "/" + country,
        {
          method: "GET",
          credentials: "include",
          responseType: "blob",
        }
      )
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          if (all) {
            a.download = "PDR-export-reviews-full.csv";
          } else {
            a.download = "PDR-export-reviews.csv";
          }
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    },
  },
};
</script>
